/* eslint-disable prettier/prettier */

import { getUsuarios, insertUsuario } from "../apis";
import axios from "axios";

import {
  getSolicitudesXedad,
  getSolicitudesXentidad,
  getSolicitudescomoEnteraron,
  getSolicitudesPorSexo,
  getSolicitudesTerapia,
  getSolicitudesAuditivo,
  getResumenSolicitudesExpedientes,
  getSolicitudesTamizNeoAuditivo,
} from "../apis";

import {
    GetSolicitudesXentidad,
    GetSolicitudesXentidadLoading,
    GetSolicitudescomoEnteraron,
    GetSolicitudescomoEnteraronLoading,
    GetSolicitudesSexo,
    GetSolicitudesSexoLoading,
    GetSolicitudesTerapia,
    GetSolicitudesTerapiaLoading,
    GetSolicitudesAuditivo,
    GetSolicitudesAuditivoLoading,
    GetSolicitudesTamiz,
    GetSolicitudesTamizLoading,
    GetSolicitudesEdad,
    GetSolicitudesEdadLoading,
    GetResumenSolicitudes,
    GetResumenSolicitudesLoading,
} from './dashboardSlice'

import { store } from '../store'


export function GetSolicitudesXentidadDasboard(dispatch, anio) {
  const token = store.getState().login.token;
  dispatch(GetSolicitudesXentidadLoading());
  const header = {
    headers: {
      "Content-Type": "application/json;charset=UTF-8",
      Authorization: `Bearer ${token}`,
    },
    params: {
      anioFiltro: anio,
    },
  };
  axios
    .get(getSolicitudesXentidad(), header)
    .then((response) => {
      if (response.data.code === "Ok") {
        dispatch(GetSolicitudesXentidad(response.data.data));
      } else {
      }
    })
    .catch((error) => {
       
    });
}

export function GetSolicitudescomoEnteraronDasboard(dispatch, anio) {
  const token = store.getState().login.token;
  dispatch(GetSolicitudescomoEnteraronLoading());
  const header = {
    headers: {
      "Content-Type": "application/json;charset=UTF-8",
      Authorization: `Bearer ${token}`,
    },
    params: {
      anioFiltro: anio,
    },
  };
  axios
    .get(getSolicitudescomoEnteraron(), header)
    .then((response) => {
      if (response.data.code === "Ok") {
        dispatch(GetSolicitudescomoEnteraron(response.data.data));
      } else {
      }
    })
    .catch((error) => {
       
    });
}

export function GetSolicitudesSexoDasboard(dispatch, anio) {
  const token = store.getState().login.token;
  dispatch(GetSolicitudesSexoLoading());
  const header = {
    headers: {
      "Content-Type": "application/json;charset=UTF-8",
      Authorization: `Bearer ${token}`,
    },
    params: {
      anioFiltro: anio,
    },
  };
  axios
    .get(getSolicitudesPorSexo(), header)
    .then((response) => {
      if (response.data.code === "Ok") {
        dispatch(GetSolicitudesSexo(response.data.data));
      } else {
      }
    })
    .catch((error) => {
       
    });
}

export function GetSolicitudesTerapiaDasboard(dispatch, anio) {
  const token = store.getState().login.token;
  dispatch(GetSolicitudesTerapiaLoading());
  const header = {
    headers: {
      "Content-Type": "application/json;charset=UTF-8",
      Authorization: `Bearer ${token}`,
    },
    params: {
      anioFiltro: anio,
    },
  };
  axios
    .get(getSolicitudesTerapia(), header)
    .then((response) => {
      if (response.data.code === "Ok") {
        dispatch(GetSolicitudesTerapia(response.data.data));
      } else {
      }
    })
    .catch((error) => {
       
    });
}

export function GetSolicitudesAuxiliarDasboard(dispatch, anio) {
  const token = store.getState().login.token;
  dispatch(GetSolicitudesAuditivoLoading());
  const header = {
    headers: {
      "Content-Type": "application/json;charset=UTF-8",
      Authorization: `Bearer ${token}`,
    },
    params: {
      anioFiltro: anio,
    },
  };
  axios
    .get(getSolicitudesAuditivo(), header)
    .then((response) => {
      if (response.data.code === "Ok") {
        dispatch(GetSolicitudesAuditivo(response.data.data));
      } else {
      }
    })
    .catch((error) => {
       
    });
}

export function GetSolicitudesTamizDasboard(dispatch, anio) {
  const token = store.getState().login.token;
  dispatch(GetSolicitudesTamizLoading());
  const header = {
    headers: {
      "Content-Type": "application/json;charset=UTF-8",
      Authorization: `Bearer ${token}`,
    },
    params: {
      anioFiltro: anio,
    },
  };
  axios
    .get(getSolicitudesTamizNeoAuditivo(), header)
    .then((response) => {
      if (response.data.code === "Ok") {
        dispatch(GetSolicitudesTamiz(response.data.data));
      } else {
      }
    })
    .catch((error) => {
       
    });
}
export function GetSolicitudesEdadDasboard(dispatch, anio) {
  const token = store.getState().login.token;
  dispatch(GetSolicitudesEdadLoading());
  const header = {
    headers: {
      "Content-Type": "application/json;charset=UTF-8",
      Authorization: `Bearer ${token}`,
    },
    params: {
      anioFiltro: anio,
    },
  };
  axios
    .get(getSolicitudesXedad(), header)
    .then((response) => {
      if (response.data.code === "Ok") {
        dispatch(GetSolicitudesEdad(response.data.data));
      } else {
      }
    })
    .catch((error) => {
       
    });
}
export function GetResumenSolicitudesDasboard(dispatch, anio) {
  const token = store.getState().login.token;
  dispatch(GetResumenSolicitudesLoading());
  const header = {
    headers: {
      "Content-Type": "application/json;charset=UTF-8",
      Authorization: `Bearer ${token}`,
    },
    params: {},
  };
  axios
    .get(getResumenSolicitudesExpedientes(), header)
    .then((response) => {
      if (response.data.code === "Ok") {
        dispatch(GetResumenSolicitudes(response.data.data));
      } else {
      }
    })
    .catch((error) => {
       
    });
}
